import React from 'react';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { IfpEligibilityCheckSteps } from 'journey/productDetails/typings';
import { useIdentity } from 'shared/hooks';
import AuthenticatedIfpEligibilityCheckButton from './AuthenticatedIfpEligibilityCheckButton';
import UnauthenticatedIfpEligibilityCheckButton from './UnauthenticatedIfpEligibilityCheckButton';

interface IfpEligibilityCheckButtonProps {
  disabled: boolean;
}

export default function IfpEligibilityCheckButton({
  disabled,
}: IfpEligibilityCheckButtonProps) {
  const { isGuest, isLoggedIn, refetchAccountList, refetchLoginStatus } =
    useIdentity();
  const { dispatch } = useProductDetails();

  function setActiveIfpCheckStep(step: IfpEligibilityCheckSteps) {
    dispatch({
      type: ProductDetailsActionTypes.SetIfpEligibility,
      ifpEligibility: {
        activeStep: step,
      },
    });
  }

  if (isLoggedIn && !isGuest) {
    return (
      <AuthenticatedIfpEligibilityCheckButton
        setActiveIfpCheckStep={setActiveIfpCheckStep}
        disabled={disabled}
      />
    );
  }

  return (
    <UnauthenticatedIfpEligibilityCheckButton
      setActiveIfpCheckStep={setActiveIfpCheckStep}
      refetchAccountList={refetchAccountList}
      refetchLoginStatus={refetchLoginStatus}
      disabled={disabled}
    />
  );
}
